/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_LoadingInputs */

const cs_draft_loading = /** @type {(inputs: Draft_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítání konceptu…`)
};

const en_draft_loading = /** @type {(inputs: Draft_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading draft…`)
};

/**
* | output |
* | --- |
* | "Loading draft…" |
*
* @param {Draft_LoadingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_loading = /** @type {((inputs?: Draft_LoadingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_LoadingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_loading(inputs)
	return cs_draft_loading(inputs)
});